module.exports = __webpack_public_path__ + "static/img/ic_elementary@2x.b1ef13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_elementary@2x.png
// module id = guaQ
// module chunks = 1